module.exports = __webpack_public_path__ + "img/master.19012ba8.jpg";